<script setup>
import { ref, reactive, computed, onMounted, watch } from 'vue'
import { Button, Icon } from '@components'

import moment from 'moment'

import { useActivity } from '@store/activity.js'
const $activity = useActivity()


const markAsRead = () => {
    console.log('mark as read')
}

const getStatusColor = (status) => {
    if (!status) return

    let s = status.toLowerCase()

    if (s == 'pending') return '#DC6803'
    if (s == 'confirmed') return '#039855'
    if (s == 'canceled ') return '#D92D20'
    if (s == 'replied') return '#475467'

    return '#101828'
}
</script>

<template>
    <div class="my-[-28px] md:max-w-[736px] m-auto">
        <div class="text-[#344054] text-2xl font-semibold pb-7">Activity</div>

        <!-- Activity list -->

        <!-- timeline -->
        <div class="flex justify-between gap-4 py-4">
            <div class="text-[#101828] text-sm font-semibold">Today, Oct 23, 2023</div>
            <Button @click="markAsRead" type="link_gray">Mark all as read</Button>
        </div>

        <!-- notifications -->
        <div class="flex flex-col gap-5">
            <!-- design 1 -->
            <!-- Note: design need to be changed. container size not matching -->
            <div class="flex gap-4 py-2 rounded-lg hover:bg-[#F2F4F7]">
                <div class="flex items-center gap-5">
                    <div class="w-[8px] h-[8px] rounded-full bg-[#9E77ED]"></div>
                    <div class="h-full">
                        <img src="https://picsum.photos/40/40" width="40" height="40" alt="" class="h-10 w-10 rounded-full bg-[#D0D5DD]">
                    </div>
                    <div>
                        <div class="text-sm font-medium text-[#101828]">Marvin McKinney booked a Hair cut and Hair wash appointment for Oct 27, 2023 - 10:00 am</div>
                        <div class="flex items-center gap-2 mt-2">
                            <div class="text-[#475467] text-xs font-normal">{{ moment("20240205", "YYYYMMDD").fromNow() }}</div>
                            <div class="w-1 h-1 rounded-full" :style="`background-color: ${getStatusColor('Pending')}`"></div>
                            <div class="text-xs font-medium" :style="`color: ${getStatusColor('Pending')}`">Pending</div>
                        </div>
                    </div>
                </div>
                <div class="flex items-center gap-3">
                    <Button type="secondary_gray" radius="square" size="sm" class="h-fit">Decline</Button>
                    <Button type="primary" radius="square" size="sm" class="h-fit">Approve</Button>
                </div>
            </div>

            <!-- design 2 -->
            <div class="flex gap-4 py-2 rounded-lg hover:bg-[#F2F4F7]">
                <div class="flex items-center gap-5">
                    <div class="w-[8px] h-[8px] rounded-full bg-[#9E77ED]"></div>
                    <div class="h-full">
                        <Icon name="userLeft01" size="40px" class="text-[#475467] bg-[#F2F4F7] rounded-full p-2.5"></Icon>
                    </div>
                    <div>
                        <div class="text-sm font-medium text-[#101828]">Elenor Pena logged in at 8:30 am</div>
                        <div class="text-[#475467] text-xs font-normal mt-2">{{ moment("20240205", "YYYYMMDD").fromNow() }}</div>
                    </div>
                </div>
            </div>

            <!-- design 3 -->
            <div class="flex gap-4 py-2 rounded-lg hover:bg-[#F2F4F7]">
                <div class="flex items-center gap-5">
                    <div class="w-[8px] h-[8px] rounded-full bg-[#9E77ED]"></div>
                    <div class="h-full">
                        <Icon name="userRight01" size="40px" class="text-[#475467] bg-[#F2F4F7] rounded-full p-2.5"></Icon>
                    </div>
                    <div>
                        <div class="text-sm font-medium text-[#101828]">Elenor Pena logged out at 8:30 am</div>
                        <div class="text-[#475467] text-xs font-normal mt-2">{{ moment("20240205", "YYYYMMDD").fromNow() }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>